/*
 *+------------------------------------------------------------------------+
 *| Licensed Materials - Property of IBM
 *| IBM Cognos Products: BI Dashboard
 *| (C) Copyright IBM Corp. 2018
 *|
 *| US Government Users Restricted Rights - Use, duplication or disclosure
 *| restricted by GSA ADP Schedule Contract with IBM Corp.
 *+------------------------------------------------------------------------+
 */

define([
	'underscore',
	'../../../lib/@waca/upgrades/UpgradeBase',
	'./utils/WidgetUpgradeUtils'
], (_, UpgradeBase, WidgetUpgradeUtils) => {

	/**
	* Upgrade 'lineColor' prop for composite chart, renaming it to 'compositeLineColor'.
	**/

	class CompositeChartUpgrade extends UpgradeBase {

		constructor() {
			super();

			this.VERSION = 1016;
		}

		/**
		 * Perform upgrade
		 *
		 * @param {object} spec - spec to perform upgrade on
		 *
		 * @return {Promise} Promise to be resolved when upgrade performed
		 */
		up(spec) {
			if (!spec) {
				return Promise.resolve(spec);
			}

			if (!WidgetUpgradeUtils.specHasWidgets(spec)) {
				return Promise.resolve(spec);
			}

			this._lineColorPropUpgrade(spec);
			return Promise.resolve(spec);
		}

		// Downgrades are not available in CA
		down(spec) {
			return Promise.resolve(spec);
		}


		_lineColorPropUpgrade(spec) {
			const lineColorPropId = 'lineColor';
			const compositeLineColorPropId = 'compositeLineColor';
			const upgradeVisId = ['com.ibm.vis.rave2bundlecomposite'];
			_.each(spec.widgets, model => {
				// we do not want to ruin the prossible lineColor prop in other models, so add a visid check here
				if (model && model.properties && model.visId && _.contains(upgradeVisId,model.visId)) {
					const deprecatedLineColorProp = WidgetUpgradeUtils.findProperty(lineColorPropId, model.properties);
					model.properties = _.filter(model.properties, (prop) => { return lineColorPropId !== prop.id; });
					if (deprecatedLineColorProp){
						model.properties.push({
							id: compositeLineColorPropId,
							value: deprecatedLineColorProp.value
						});
					}
				}
			});
		}
	}

	return new CompositeChartUpgrade();
});
